import styled from 'styled-components';
import WithDirection from '@iso/lib/helpers/rtl';

const ManageFormPage = styled.div`
  width: 100%;
  height: 100%;
  
  .button-group{
    width: 100%;
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }
`;

export default WithDirection(ManageFormPage);